import { render } from "./MenoresSelector.vue?vue&type=template&id=54626f22&scoped=true&ts=true"
import script from "./MenoresSelector.vue?vue&type=script&lang=ts"
export * from "./MenoresSelector.vue?vue&type=script&lang=ts"

import "./MenoresSelector.vue?vue&type=style&index=0&id=54626f22&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/front-publico/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54626f22"]])

export default __exports__